export default function getRandomNumberUtil (lower = 0, upper = 999999999999999, floating = false) {
  if (floating || lower % 1 || upper % 1) {
    const rand = Math.random()
    return Math.min(lower, upper) + rand * Math.abs(upper - lower)
  }
  return Math.floor(Math.random() * (upper - lower + 1)) + lower
}
